import { Route } from "@angular/router";
import { RecuperarPage } from "./recuperar.page";

export const RecuperarRouter: Route[] = [
  { path: 'recuperar', component: RecuperarPage }
];